module.exports = __webpack_public_path__ + "img/Stripe.563e2048.png";